import { Button, ButtonGroup, Card, InputAdornment, Stack, Switch, TextField, Typography } from "@mui/material";
import DeleteSweepOutlinedIcon from "@mui/icons-material/DeleteSweepOutlined";
import PublishedWithChangesOutlinedIcon from "@mui/icons-material/PublishedWithChangesOutlined";
import SwipeLeftAltOutlinedIcon from "@mui/icons-material/SwipeLeftAltOutlined";
import { PiArrowDownLeft, PiArrowLineUpLeft } from "react-icons/pi";
import { AiOutlineSwap } from "react-icons/ai";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CachedIcon from "@mui/icons-material/Cached";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { changeConformity } from "Redux/filtersSlice";
import {
  changeSelectingType,
  clearDestinationZones,
  clearSourceZones,
  SelectingType,
  swapZones,
  changeAutoApply,
  changeApplySelected,
  toggleForceUpdate,
  changeZonesCount,
  toggleShowTopNumbers,
  toggleClearModeUpdate,
} from "Redux/zonesSlice";

import MenuButton from "./Button";

export default function Filter() {
  const dispatch = useAppDispatch();

  const { selectingType, autoApply, applySelecteds, forceUpdate, zonesCount, showTopNumbers, destination, source } =
    useAppSelector((state) => state.zones);
  const { conformity } = useAppSelector((state) => state.filters);

  const handleChangeSelectingType = (type: SelectingType) => {
    dispatch(changeSelectingType(type));
  };
  const handleAutoAplly = () => {
    if (!autoApply) {
      dispatch(changeApplySelected(false));
    }
    dispatch(changeAutoApply(!autoApply));
  };
  const handleApplySelectreds = () => {
    if (!autoApply) {
      dispatch(changeApplySelected(true));
    }
    dispatch(toggleForceUpdate());
  };
  const handleClickConformityButton = (type: "source" | "destination") => {
    dispatch(changeConformity(type));
  };

  const handleSwap = () => {
    if (selectingType === "source") {
      dispatch(changeSelectingType("destination"));
    } else if (selectingType === "destination") {
      dispatch(changeSelectingType("source"));
    }
    dispatch(changeApplySelected(false));
    dispatch(swapZones());
  };

  const handleZonesCount = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (Number(e.target.value) > 0) {
      dispatch(changeZonesCount(Number(e.target.value)));
    }
  };
  const label = { inputProps: { "aria-label": "Switch demo" } };
  return (
    <Card sx={{ p: 1.5 }}>
      <Stack direction="row" spacing={1}>
        <ButtonGroup disableElevation>
          <MenuButton
            extraSx={{ "&:hover": { borderColor: "#ccc" }, width: "56px" }}
            disabled={autoApply}
            onClick={() => handleApplySelectreds()}
          >
            <CachedIcon />
          </MenuButton>
          <MenuButton
            extraSx={{ "&:hover": { borderColor: "#ccc" }, width: "56px", minWidth: "100px" }}
            onClick={() => handleAutoAplly()}
          >
            {autoApply ? "رفرش اتومات" : "رفرش دستی"}
          </MenuButton>
        </ButtonGroup>
        <ButtonGroup disableElevation>
          <MenuButton
            onClick={() => {
              dispatch(toggleClearModeUpdate());
              dispatch(clearSourceZones());
            }}
            sx={{ width: "44px" }}
          >
            <DeleteOutlineIcon />
          </MenuButton>
        </ButtonGroup>
        <Stack direction="row" sx={{ padding: "0px", justifyContent: "space-between" }}>
          <TextField
            id="outlined-number"
            label="بیشترین‌ها"
            type="number"
            style={{ borderRadius: "60px" }}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{ style: { width: "75px", borderRadius: "50px" } }}
            value={zonesCount}
            onChange={handleZonesCount}
            disabled={source.length > 0 && destination.length > 0 && applySelecteds}
          />
          <Button
            onClick={() => dispatch(toggleShowTopNumbers())}
            variant={showTopNumbers ? "contained" : "light"}
            sx={{ width: "80px", ml: "3px", padding: "0" }}
            disabled={source.length > 0 && destination.length > 0 && applySelecteds}
          >
            نمایش بیشترین‌ها
          </Button>
        </Stack>
      </Stack>
    </Card>
  );
}
